export default __webpack_public_path__ + "images/f6800c2f8ce6ea67bc61171c469e91cd.jpg";